import React from 'react';
import PropTypes from 'prop-types';
import Text from '../Text';

import * as styles from './ActionLinks.module.less';

const processLinks = links => {
  return links
    .map(l => {
      if (l.text === 'How It Works') {
        return {
          ...l,
          text: `See ${l.text}`,
        };
      }
      return l;
    })
    .reverse();
};

const ActionLinks = ({ links }) => {
  if (!links || links.length === 0) return null;
  return (
    <div className={styles.wrapper}>
      <p>Want to know more about Fundera?</p>
      <ul className={styles.list}>
        {processLinks(links).map((link, index) => (
          <li className={styles.item} key={link.text}>
            {index > 0 && <Text>&nbsp;or&nbsp;</Text>}
            <a href={link.path}>{link.text}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

ActionLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
};

ActionLinks.defaultProps = {
  links: null,
};

export default ActionLinks;
